import {deserialize} from 'libs/cerialize';

export class SubFlowDto {
	@deserialize
	Id: number;

	@deserialize
	Name: string;
}
